var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.extensions),function(item,index){return _c('v-switch',{key:item.id,attrs:{"label":item.name,"color":item.id,"hide-details":""},on:{"change":function($event){return _vm.saveExtensions(_vm.extensions)}},model:{value:(item.enabled),callback:function ($$v) {_vm.$set(item, "enabled", $$v)},expression:"item.enabled"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }